const isTest1 = document.querySelector('.test-1-variant-1')
const isTest2 = document.querySelector('.test-2-variant-1')
const isTest22 = document.querySelector('.test-2-variant-1-2')
const isTest3 = document.querySelector('.test-3-variant-1')

/****** Test 1 *********/
class CollectionPageTest {
    constructor() {
        this.init();
    }

    changeBreadcrumbIcons() {
        document.querySelectorAll('.breadcrumbs__icon').forEach(icon => icon.innerHTML = '/');
    }
    
    highlightCurrentCollection() {
        const currentPath = decodeURIComponent(window.location.pathname);
        
        // Note: Using the generic .swiper-slide selector inside your container
        const collectionLinks = document.querySelectorAll('.ss-circle-menu-2-section a.swiper-slide');
        
        collectionLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (!href) return;

            const linkPath = decodeURIComponent(href);
            
            if (currentPath === linkPath || currentPath.startsWith(linkPath + '/')) {
                link.classList.add('is-active-collection');
            }
        });
    }

    increaseSwiperGap() {
        if (window.innerWidth >= 768) return;
        const newGapSize = 16; 
        
        // Find the main Swiper container
        const swiperContainer = document.querySelector('.ss-circle-menu-2-section .swiper');
        
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.params.spaceBetween = newGapSize;
            swiperContainer.swiper.params.slidesPerView = 3.2
            swiperContainer.swiper.update(); 
        }
    }

    init() {
        this.changeBreadcrumbIcons();
        this.highlightCurrentCollection();
        
        // Delaying slightly to ensure Swiper has finished its initial load
        setTimeout(() => {
            this.increaseSwiperGap();
        }, 200);

    }
}
if(isTest1)
    new CollectionPageTest()

/****** Test 1 End *****/
/****** Test 2**********/
class ProductPageTest {
    constructor() {
        this.pollAttempts = 0;
        this.maxAttempts = 10; // Poll for 5 seconds (10 * 500ms)
        this.init();
    }

    setMediaHeightVariable() {
        // Only run on desktop (assuming standard 768px breakpoint for mobile)
        if (window.innerWidth < 768) return;

        const mediaContainer = document.querySelector('.product__media-container.above-mobile .product__media');
        if (mediaContainer) {
            const parent = mediaContainer.parentElement;
            if (parent) {
                // Get the height and set it as a CSS variable on the parent
                const mediaHeight = mediaContainer.offsetHeight;
                parent.style.setProperty('--media-height', `${mediaHeight}px`);
                
                // Optional: Recalculate on window resize in case they drag the window
                if (!mediaContainer.dataset.resizeListener) {
                    window.addEventListener('resize', () => {
                        if (window.innerWidth >= 768) {
                            parent.style.setProperty('--media-height', `${mediaContainer.offsetHeight}px`);
                        } else {
                            parent.style.removeProperty('--media-height');
                        }
                    });
                    mediaContainer.dataset.resizeListener = 'true';
                }
            }
        }
    }

    moveReviewStars() {
        const title = document.querySelector('.product__title');
        const reviewBadge = document.querySelector('.jdgm-preview-badge');
        if (title && reviewBadge) {
            const reviewBadgeBlock = reviewBadge.closest('.shopify-app-block') || reviewBadge;
            title.after(reviewBadgeBlock);
        }
    }

    moveAfterpay() {
        const price = document.querySelector('.product__price-and-ratings');
        const afterpay = document.querySelector('square-placement');
        if (price && afterpay) {
            const afterpayBlock = afterpay.closest('.shopify-app-block') || afterpay;
            price.after(afterpayBlock);
        }
    }

    modifyEngraveButton() {
        const engraveBtn = document.querySelector('.pplr-c-button');
        if (engraveBtn) {
            engraveBtn.style.width = '100%';
            engraveBtn.style.display = 'block';
            engraveBtn.style.marginBottom = '10px';
        }
    }

    modifyNativeAtcButton() {
        // Hide the original checkbox
        const checkboxContainer = document.querySelector('.enable-engrave-product-option');
        if (checkboxContainer) {
            checkboxContainer.style.display = 'none';
        }

        // Target the existing native Add to Bag button and its text span
        const nativeAtcBtn = document.querySelector('.product-form__cart-submit');
        const nativeAtcText = document.querySelector('.product-form__cart-submit [data-add-to-cart-text]');

        if (nativeAtcBtn && nativeAtcText && !nativeAtcBtn.dataset.modified) {
            // 1. Change the text of the existing button
            nativeAtcText.textContent = 'Add to Bag (No Engrave)';
            nativeAtcBtn.dataset.modified = "true";
            nativeAtcBtn.disabled = false;
            nativeAtcBtn.classList.remove('disabled')

            // 2. Add listener to check the hidden box when clicked so Zepto doesn't block it
            nativeAtcBtn.addEventListener('click', () => {
                const engraveCheckbox = document.getElementById('enable-engrave');
                if (engraveCheckbox) {
                    engraveCheckbox.checked = true;
                    // Trigger a change event just in case the app is listening for it
                    engraveCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }
    }

    moveNoReturnsText() {
        const productPolicies = document.querySelector('.product__policies');
        const descriptionParagraphs = document.querySelectorAll('.product__description p');
        
        if (!productPolicies) return;

        // Loop through paragraphs to find the exact text
        let targetElement = null;
        for (let p of descriptionParagraphs) {
            if (p.textContent.includes('No returns accepted if you engrave items.')) {
                targetElement = p;
                break;
            }
        }

        // If it exists on this product and hasn't been moved yet, move it
        if (targetElement && !targetElement.dataset.moved) {
            targetElement.dataset.moved = "true";
            targetElement.classList.add('test-2-no-returns-text')
            productPolicies.before(targetElement);
        }
    }

    removeExtraDescription() {
        const descContainer = document.querySelector('.product__description .rte');
        if (!descContainer || descContainer.dataset.extraRemoved) return;

        // 1. Target and remove the bold title and its trailing line break
        const firstStrong = descContainer.querySelector('strong');
        if (firstStrong) {
            const nextElement = firstStrong.nextElementSibling;
            if (nextElement && nextElement.tagName === 'BR') {
                nextElement.remove();
            }
            firstStrong.remove();
        }

        // 2. Hide everything after the check marks
        let foundChecks = false;
        
        // Go through all direct children of the description container
        Array.from(descContainer.children).forEach(child => {
            // If the element has a checkmark, note that we are in the "check" section
            if (child.textContent.includes('✔')) {
                foundChecks = true;
            } 
            // If we have passed the checks, and this element doesn't have one, hide it
            else if (foundChecks) {
                child.style.display = 'none';
            }
        });

        descContainer.dataset.extraRemoved = 'true';
    }

    replaceCheckmarksWithSvg() {
        const descContainer = document.querySelector('.product__description .rte');
        
        if (descContainer && !descContainer.dataset.svgReplaced) {
            // Add flex-shrink: 0 to ensure the SVG doesn't squish if the text wraps
            const checkSvg = `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9ZM13.5337 5.59125C13.4534 5.51117 13.3577 5.44812 13.2524 5.40587C13.1471 5.36361 13.0344 5.34303 12.921 5.34534C12.8076 5.34765 12.6958 5.37281 12.5923 5.41931C12.4888 5.46582 12.3958 5.53271 12.3187 5.616L8.41162 10.5941L6.057 8.23837C5.89705 8.08933 5.6855 8.0082 5.46691 8.01205C5.24832 8.01591 5.03976 8.10446 4.88518 8.25905C4.73059 8.41364 4.64204 8.6222 4.63818 8.84079C4.63432 9.05938 4.71546 9.27093 4.8645 9.43088L7.84125 12.4087C7.92144 12.4888 8.01693 12.5519 8.12203 12.5942C8.22713 12.6366 8.33968 12.6573 8.45296 12.6552C8.56625 12.6531 8.67795 12.6282 8.78141 12.582C8.88486 12.5358 8.97795 12.4692 9.05512 12.3863L13.5461 6.7725C13.6992 6.61331 13.7838 6.40043 13.7817 6.17958C13.7796 5.95872 13.691 5.74749 13.5349 5.59125H13.5337Z" fill="#605AA8"/>
            </svg>`;
            
            // Regex to grab the checkmark and text, stopping at <br> or paragraph end.
            // It automatically consumes the <br> so we don't have dangling spacing.
            const regex = /✔\s*([\s\S]*?)(?:<br[^>]*>|(?=<\/p>|$))/gi;
            
            descContainer.innerHTML = descContainer.innerHTML.replace(regex, `
                <div class="custom-check-item">
                    ${checkSvg}
                    <span class="custom-check-text">$1</span>
                </div>
            `);
            
            descContainer.dataset.svgReplaced = 'true';
        }
    }

    moveWidgetsUnderReviews() {
        const reviewCarousel = document.getElementById('jdgm-review-snippet-wrapper');
        const stackSaveText = document.getElementById('bh2o-option-c');
        const stackSaveWidget = document.getElementById('bh2o-stack-save');
        const completeLook = document.getElementById('bh2o-complete-look');

        if (reviewCarousel) {
            const reviewCarouselBlock = reviewCarousel.closest('.shopify-app-block') || reviewCarousel;
            
            if (stackSaveText && stackSaveWidget && completeLook) {
                reviewCarouselBlock.after(stackSaveText, stackSaveWidget, completeLook);
            }
        }
    }

    runMutations() {
        debugger;
        this.setMediaHeightVariable();
        this.moveReviewStars();
        this.moveAfterpay();
        this.modifyNativeAtcButton();
        this.moveNoReturnsText();
        this.removeExtraDescription(); 
        this.replaceCheckmarksWithSvg();
        this.moveWidgetsUnderReviews();
    }

    init() {
        // Run immediately for native DOM elements
        this.runMutations();

        // Setup polling for the third-party app blocks
        const poller = setInterval(() => {
            this.runMutations();
            this.pollAttempts++;
            
            // Stop polling after 5 seconds to prevent performance drag
            if (this.pollAttempts >= this.maxAttempts) {
                clearInterval(poller);
            }
        }, 500);
    }
}
if(isTest2)
    new ProductPageTest();
/****** Test 2 End *****/

/****** Test 2 2.0 **********/
/****** Test 2 2.0 **********/
class ProductPageTest2 {
    constructor() {
        this.pollAttempts = 0;
        this.maxAttempts = 10; // Poll for 5 seconds (10 * 500ms)
        this.init();
    }

    setMediaHeightVariable() {
        // Only run on desktop (assuming standard 768px breakpoint for mobile)
        if (window.innerWidth < 768) return;

        const mediaContainer = document.querySelector('.product__media-container.above-mobile .product__media');
        if (mediaContainer) {
            const parent = mediaContainer.parentElement;
            if (parent) {
                // Get the height and set it as a CSS variable on the parent
                const mediaHeight = mediaContainer.offsetHeight;
                parent.style.setProperty('--media-height', `${mediaHeight}px`);
                
                // Optional: Recalculate on window resize in case they drag the window
                if (!mediaContainer.dataset.resizeListener) {
                    window.addEventListener('resize', () => {
                        if (window.innerWidth >= 768) {
                            parent.style.setProperty('--media-height', `${mediaContainer.offsetHeight}px`);
                        } else {
                            parent.style.removeProperty('--media-height');
                        }
                    });
                    mediaContainer.dataset.resizeListener = 'true';
                }
            }
        }
    }

    moveSectionStoreReviewSummary() {
        const reviewSummary = document.querySelector('section-store--review-summary-block');
        // We look for the main product form as the anchor point to place the reviews before
        const productForm = document.querySelector('form[action*="/cart/add"]');
        
        if (reviewSummary && productForm) {
            const reviewSummaryBlock = reviewSummary.closest('.shopify-app-block') || reviewSummary;
            
            // Only move if it hasn't been moved yet
            if (!reviewSummary.dataset.moved) {
                productForm.before(reviewSummaryBlock);
                reviewSummary.dataset.moved = "true";
            }
        }
    }

    moveWidgetsUnderForm() {
        // Target the native Shopify product form
        const productForm = document.querySelector('form[action*="/cart/add"]');
        
        const stackSaveText = document.getElementById('bh2o-option-c');
        const stackSaveWidget = document.getElementById('bh2o-stack-save');
        const completeLook = document.getElementById('bh2o-complete-look');

        // Ensure the form and all widget pieces exist before moving
        if (productForm && stackSaveText && stackSaveWidget && completeLook) {
            
            // Move widgets only if they haven't been moved yet
            if (!stackSaveWidget.dataset.moved) {
                // Insert them directly after the form
                productForm.after(stackSaveText, stackSaveWidget, completeLook);
                stackSaveWidget.dataset.moved = "true";
            }
        }
    }

    runMutations() {
        this.setMediaHeightVariable();
        this.moveSectionStoreReviewSummary();
        this.moveWidgetsUnderForm();
    }

    init() {
        // Run immediately for native DOM elements
        this.runMutations();

        // Setup polling for the third-party app blocks
        const poller = setInterval(() => {
            this.runMutations();
            this.pollAttempts++;
            
            // Stop polling after 5 seconds to prevent performance drag
            if (this.pollAttempts >= this.maxAttempts) {
                clearInterval(poller);
            }
        }, 500);
    }
}
if(isTest22)
    new ProductPageTest2();
/****** Test 2 2.0 End **********/

/****** Test 3 *********/
class CartDrawerTest {
    constructor() {
        this.observerTarget = document.querySelector('.quick-cart');
        this.observerConfig = { attributes: true, childList: true, subtree: true };

        this.init();
    }

    // Helper to dynamically calculate accurate cart count from inputs
    getCartCount() {
        let count = 0;
        const quantityInputs = document.querySelectorAll('.quick-cart__items .quantity-input__input');
        quantityInputs.forEach(input => {
            count += parseInt(input.value, 10) || 0;
        });
        return count;
    }

    //Override shadow attach api
    overrideShadowAndAppendStylesToRedo(){
        const originalAttachShadow = Element.prototype.attachShadow;

        Element.prototype.attachShadow = function(init) {
        if (this.tagName === "REDO-SHOPIFY-TOGGLE") {
            return originalAttachShadow.call(this, { ...init, mode: 'open' });
        }
        return originalAttachShadow.call(this, init);
        };

        const observer = new MutationObserver((mutations, obs) => {
            const el = document.querySelector('redo-shopify-toggle');

            if (!el) return;

            setTimeout(() => {
                if (el.shadowRoot) {
                    console.log('Shadow root accessed:', el.shadowRoot);
                    if (!el.shadowRoot.querySelector('#my-style')) {
                        const style = document.createElement('style');
                        style.id = 'my-style';
                        style.textContent = `
                            div[data-target="info-card-container"]{
                                margin: 12px 0 !important;
                            }

                            button[data-target="coverage-button"]{
                                --button-height: var(--height-input);
                                min-height: var(--button-height);
                                cursor: pointer;
                                width: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: var(--button-padding-normal);
                                line-height: var(--line-height-button);
                                position: relative;
                                overflow: hidden;
                                background: transparent;
                                z-index: 1;
                                font-size: 0.95rem !important;
                                text-transform: uppercase !important;
                                background-color: #db124b !important;
                                color: #fff !important;
                                border: none !important;
                                border-radius: 10px !important;
                                font-family: 'Cormorant Garamond', serif !important;
                                font-weight: 700 !important;
                                letter-spacing: 1px !important;
                                box-shadow: 0 3px 12px rgba(219, 18, 75, 0.2) !important;
                                margin-top: 0 !important;
                                margin-bottom: 0 !important;
                            }

                            button[data-target="coverage-button"] * {
                                color: var(--color-white-solid, #FFF);
                                text-align: center;
                                font-size: 15.2px;
                                font-style: normal;
                                font-weight: 700;
                                line-height: 22px; /* 144.737% */
                                letter-spacing: 1px;
                                text-transform: uppercase;
                                font-family: 'Cormorant Garamond', serif !important;
                            }

                            button[data-target="coverage-button"]:after,button[data-target="coverage-button"]:before {
                                content: "";
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                pointer-events: none;
                            }

                            button[data-target="coverage-button"]:before {
                                width: 140%;
                                left: -20%;
                                background: var(--color-background-button);
                                z-index: -1;
                                transform: skew(30deg);
                                transition: transform .5s cubic-bezier(.33, 0, 0, 1);
                                transition: transform var(--duration-normal) var(--easing);
                            }

                            button[data-target="coverage-button"]:after {
                                background-color: var(--color-background-button-hover);
                                z-index: -2;
                            }

                            button[data-target="coverage-button"]:hover:before{
                                transform: translate3d(100%, 0, 0);
                            }

                            div[data-target="checkout-buttons-container"] {
                                margin: 0 !important;
                            }

                            button[data-target="non-coverage-button"] {
                                display: none;
                            }
                        `;
                        el.shadowRoot.appendChild(style);
                    }

                    const btn = el.shadowRoot.querySelector('button[data-target="coverage-button"]');
                    if (btn) {
                        btn.innerText = 'SECURE CHECKOUT';
                    }
                } else {
                    console.warn('Shadow root still not accessible');
                }
            }, 0);
        });

        // Start observing
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
    }

    getShippingCost(total) {
        const country = window.Shopify?.country || 'US'; 
        
        if (country === 'AU') {
            return total >= 149 ? 0 : 9.95;
        } else if (country === 'NZ') {
            return total >= 149 ? 0 : 13.95;
        } else {
            return 25.00; 
        }
    }

    updateHeaderCount() {
        const header = document.querySelector('.quick-cart__header');
        if (!header) return;

        const h2 = header.querySelector('h2');
        const totalCount = this.getCartCount();

        if (h2) {
            if (!h2.dataset.modified) {
                h2.innerHTML = `Your Order <span class="custom-cart-count">(${totalCount})</span>`;
                h2.dataset.modified = 'true';
            } else {
                const countSpan = h2.querySelector('.custom-cart-count');
                if (countSpan) countSpan.textContent = `(${totalCount})`;
            }
        }

        const sup = header.querySelector('sup');
        if (sup) sup.style.display = 'none';
    }

    reorderBanners() {
        const shippingBanner = document.querySelectorAll('.bh2o-shipping-banner');
        const upsellText = document.querySelector('.bh2o-upsell');
        const savingsText = document.querySelector('.bh2o-savings');

        const sectionToMoveBehind = upsellText ?? savingsText;
        if (shippingBanner.length && sectionToMoveBehind) {
            Array.from(shippingBanner).reverse().forEach(shippingBanner => {
                if (!shippingBanner.dataset.moved) {
                    sectionToMoveBehind.before(shippingBanner);
                    shippingBanner.dataset.moved = 'true';
                }
            });
        }
    }

    removeClutter() {
        const trustBadges = document.querySelector('.bh2o-trust');
        const paymentBadgesTop = document.querySelector('.bh2o-payments');
        const bottomExtras = document.getElementById('bh2o-cart-extras');
        const topSavingsBanner = document.querySelector('.bh2o-savings');

        if (trustBadges) trustBadges.style.display = 'none';
        if (paymentBadgesTop) paymentBadgesTop.style.display = 'none';
        if (bottomExtras) bottomExtras.style.display = 'none';

        if (topSavingsBanner) topSavingsBanner.style.display = 'none';
    }

    removeAUD() {
        const targetSelectors = [
            '.quick-cart__item-price', 
            '.a_pplr_item_oprice', 
            '.cross-sells__item-price',
            '.cross-sells__item-price-wrapper'
        ];
        
        document.querySelectorAll(targetSelectors.join(', ')).forEach(el => {
            el.childNodes.forEach(child => {
                if (child.nodeType === Node.TEXT_NODE && /AUD/i.test(child.textContent)) {
                    child.textContent = child.textContent.replace(/\s*AUD/ig, '');
                }
            });
        });
    }

    formatPriceAndQty() {
        document.querySelectorAll('.quick-cart__item-details').forEach(details => {
            const priceWrap = details.querySelector('.quick-cart__item-price-wrapper');
            const qtyInput = details.querySelector('.quantity-input');

            if (priceWrap && qtyInput && !qtyInput.dataset.moved) {
                const flexRow = document.createElement('div');
                flexRow.className = 'custom-price-qty-row';
                priceWrap.before(flexRow);
                flexRow.appendChild(priceWrap);
                flexRow.appendChild(qtyInput);
                qtyInput.dataset.moved = 'true';
            }

            if (qtyInput) {
                const inputEl = qtyInput.querySelector('.quantity-input__input');
                const minusBtn = qtyInput.querySelector('.product__quantity-subtract-item');

                if (inputEl && minusBtn) {
                    const qty = parseInt(inputEl.value);
                    if (qty <= 1) {
                        minusBtn.innerHTML = `
                            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.599609 3.26611H11.2663" stroke="#343233" stroke-width="1.19971" stroke-linecap="square" stroke-linejoin="round"/>
                                <path d="M4.65332 6.01416V9.6059" stroke="#343233" stroke-width="1.19971" stroke-linecap="square" stroke-linejoin="round"/>
                                <path d="M7.21289 6.01416V9.6059" stroke="#343233" stroke-width="1.19971" stroke-linecap="square" stroke-linejoin="round"/>
                                <path d="M1.2666 3.26611C1.37915 4.61669 1.80502 8.18442 2.08693 10.497C2.23341 11.6987 3.25387 12.5995 4.46442 12.5995C5.42195 12.5995 6.50096 12.5995 7.41736 12.5995C8.63064 12.5995 9.6528 11.6948 9.79632 10.49C10.0718 8.17651 10.4877 4.61321 10.5999 3.26611" stroke="#343233" stroke-width="1.19971" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.93262 3.26627V1.26627C3.93262 1.08947 4.00286 0.919897 4.12788 0.794873C4.25291 0.669849 4.42247 0.599609 4.59928 0.599609H7.26598C7.44278 0.599609 7.6123 0.669849 7.73734 0.794873C7.86238 0.919897 7.93262 1.08947 7.93262 1.26627V3.26627" stroke="#343233" stroke-width="1.19971" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`;
                    } else {
                        minusBtn.innerHTML = `<svg class="custom-minus-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"></path></svg>`;
                    }
                }
            }
        });
    }

    buildBreakdown() {
        const footerInner = document.querySelector('.quick-cart__footer-inner');
        const oldSubtotalContainer = document.querySelector('.quick-cart__footer-subtotal');
        const cartItemsContainer = document.querySelector('.quick-cart__items');

        if (!footerInner || !oldSubtotalContainer || !cartItemsContainer) return;

        const countInt = this.getCartCount();
        const itemLabel = countInt === 1 ? 'item' : 'items';
        const countStr = `${countInt} ${itemLabel}`;

        const numRegex = /([\d,]+\.\d{2})/;
        const parsePrice = (str) => {
            const match = str.match(numRegex);
            return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
        };

        let calculatedOriginalTotal = 0;
        let calculatedFinalTotal = 0;

        const cartItems = document.querySelectorAll('.quick-cart__item');
        cartItems.forEach(item => {
            const qtyInput = item.querySelector('.quantity-input__input');
            const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

            const priceWrapper = item.querySelector('.quick-cart__item-price-wrapper');
            if (!priceWrapper) return;

            const originalPriceEl = priceWrapper.querySelector('s.quick-cart__item-price, s.a_pplr_item_oprice');
            const finalPriceEl = priceWrapper.querySelector('span.quick-cart__item-price');

            let itemOriginalPrice = 0;
            let itemFinalPrice = 0;

            if (finalPriceEl) {
                itemFinalPrice = parsePrice(finalPriceEl.textContent);
            }

            if (originalPriceEl) {
                itemOriginalPrice = parsePrice(originalPriceEl.textContent);
            } else {
                itemOriginalPrice = itemFinalPrice;
            }

            calculatedOriginalTotal += (itemOriginalPrice * qty);
            calculatedFinalTotal += (itemFinalPrice * qty);
        });

        const savingsVal = calculatedOriginalTotal - calculatedFinalTotal;

        const shippingCost = this.getShippingCost(calculatedFinalTotal);

        const grandTotalOriginal = calculatedOriginalTotal + shippingCost;
        const grandTotalFinal = calculatedFinalTotal + shippingCost;

        const priceEl = oldSubtotalContainer.querySelector('.a_pplr_item_line_price, .pplr_subtotal_price');
        const priceStrRaw = priceEl ? priceEl.textContent.trim() : '';
        const priceStrCleaned = priceStrRaw.replace(/\s*AUD/ig, '');

        const subtotalStr = priceStrCleaned.replace(numRegex, calculatedOriginalTotal.toFixed(2));
        const savingsStr = savingsVal > 0.01 ? `$${savingsVal.toFixed(2)}` : '';
        const shippingStr = shippingCost === 0 ? 'FREE' : priceStrCleaned.replace(numRegex, shippingCost.toFixed(2));
        
        const finalOriginalStr = priceStrCleaned.replace(numRegex, grandTotalOriginal.toFixed(2));
        const finalGrandTotalStr = priceStrCleaned.replace(numRegex, grandTotalFinal.toFixed(2));

        if (priceEl) {
            priceEl.style.display = 'none'; 
        }

        let customPriceUi = oldSubtotalContainer.querySelector('.custom-subtotal-price-ui');
        if (!customPriceUi) {
            customPriceUi = document.createElement('div');
            customPriceUi.className = 'custom-subtotal-price-ui';
            customPriceUi.style.display = 'flex';
            customPriceUi.style.alignItems = 'center';
            customPriceUi.style.justifyContent = 'flex-end'; 
            customPriceUi.style.gap = '7.5px';

            if (priceEl) {
                priceEl.parentNode.insertBefore(customPriceUi, priceEl.nextSibling);
            } else {
                oldSubtotalContainer.appendChild(customPriceUi);
            }
        }

        if (savingsVal > 0.01) {
            customPriceUi.innerHTML = `
                <s class="custom-old-price" style="color: #999; font-weight: 400;">${finalOriginalStr}</s>
                <span class="custom-final-price">${finalGrandTotalStr}</span>
            `;
        } else {
            customPriceUi.innerHTML = `
                <span class="custom-final-price">${finalGrandTotalStr}</span>
            `;
        }

        let breakdown = document.querySelector('.custom-cart-breakdown');
        if (!breakdown) {
            breakdown = document.createElement('div');
            breakdown.className = 'custom-cart-breakdown';
            cartItemsContainer.appendChild(breakdown);
        }

        breakdown.innerHTML = `
            <div class="custom-breakdown-row custom-subtotal-row">
                <span class="custom-breakdown-label">Subtotal (<span class="custom-breakdown-count">${countStr}</span>)</span>
                <span class="custom-breakdown-value">${subtotalStr}</span>
            </div>
            ${savingsVal > 0.01 ? `
            <div class="custom-breakdown-row custom-savings-row" style="color: #db124b; font-weight: 600;">
                <span class="custom-breakdown-label">You Save</span>
                <span class="custom-breakdown-value">${savingsStr}</span>
            </div>
            ` : ''}
            <div class="custom-breakdown-row custom-shipping-row">
                <span class="custom-breakdown-label">Shipping</span>
                <span class="custom-breakdown-value" ${shippingCost === 0 ? 'style="font-weight: 600;"' : ''}>${shippingStr}</span>
            </div>
            <div class="custom-breakdown-row custom-total-row">
                <span class="custom-breakdown-label custom-total-label">TOTAL</span>
                <span class="custom-breakdown-value custom-total-value" style="display: flex; align-items: center; gap: 6px;">
                    ${savingsVal > 0.01 ? `<s style="color: #999; font-weight: 400; font-size: 0.85em;">${finalOriginalStr}</s>` : ''}
                    ${finalGrandTotalStr}
                </span>
            </div>
        `;
    }

    updateFooterPayments() {
        const taxNote = document.querySelector('.quick-cart__footer-tax-note');

        if (taxNote && !document.querySelector('.custom-payment-icons')) {
            taxNote.style.display = 'none';
            const payments = document.createElement('div');
            payments.className = 'custom-payment-icons';
            
            const country = window.Shopify?.country || 'US';
            const isOceania = country === 'AU' || country === 'NZ';

            let iconsHtml = `
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/0ee6e1ebdc02f7ef5ca8dfcab9aa944afb618d43.png?v=1775083368" alt="Visa"/></span>
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/bcb2246dcd36b5a7f1b57259e723258ec2c51d16.png?v=1775083368" alt="Mastercard"/></span>
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/f19bc6720da56018f113bb71105a5c7a4cd1bb4a.png?v=1775083368" alt="American Express"/></span>
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/5825ae72b8c9e704a09096666e6075306a0b833b.png?v=1775083368" alt="Apple Pay"/></span>
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/c166d720c5d7057cdab9cfa5f8b3c3f691a34909.png?v=1775083368" alt="PayPal"/></span>
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/a3489c7df934756099e2f7435add6e7492c9740b.png?v=1775083368" alt="ShopPay"/></span>
            `;

            if (isOceania) {
                iconsHtml += `
                <span class="custom-payment-icon"><img width="35px" height="35px" class='custom-payment-icon-img' src="https://cdn.shopify.com/s/files/1/0075/8061/4707/files/56388be1d5503d5b397927184d0d72e0f3a8d343.png?v=1775083368" alt="AfterPay"/></span>
                `;
            }

            payments.innerHTML = iconsHtml;
            taxNote.after(payments);
        }
    }

    updateCheckoutButton() {
        const checkoutBtn = document.querySelector('.quick-cart__submit');
        if (checkoutBtn && checkoutBtn.textContent.trim() !== 'Secure Checkout') {
            checkoutBtn.textContent = 'Secure Checkout';
        }
    }

    runMutations(observer = null) {
        if (observer) observer.disconnect();
        this.updateHeaderCount();
        this.reorderBanners();
        this.removeAUD(); 
        this.buildBreakdown();
        this.removeClutter();
        this.formatPriceAndQty();
        this.updateFooterPayments();
        this.updateCheckoutButton();
        this.overrideShadowAndAppendStylesToRedo()
        if (observer) observer.observe(this.observerTarget, this.observerConfig);
    }

    debounce(fn, delay = 100) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    init() {
        this.runMutations();

        const debouncedRun = this.debounce((observer) => {
            this.runMutations(observer);
        }, 100);

        const observer = new MutationObserver((mutations, observer) => {
            let shouldRun = false;

            for (const mutation of mutations) {
                if (
                    mutation.type === 'childList' ||
                    mutation.type === 'subtree' ||
                    mutation.type === 'characterData'
                ) {
                    shouldRun = true;
                    break;
                }
            }

            if (shouldRun) {
                debouncedRun(observer);
            }
        });

        observer.observe(this.observerTarget, this.observerConfig);
    }
}

if(typeof isTest3 !== 'undefined' && isTest3) {
    new CartDrawerTest();
}
/****** Test 3 End *****/